import React from 'react';
import { Link } from 'react-router-dom';
import { Crown } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-white dark:bg-dark-paper border-t dark:border-dark-border mt-auto">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <Crown className="w-6 h-6 text-royal-purple" />
              <span className="text-xl font-bold text-royal-purple">RoyaltySuite</span>
            </div>
            <p className="text-gray-600 dark:text-gray-400">
              A social platform for distinguished individuals, offering exclusive content and premium experiences.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-dark-primary mb-4">Legal</h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/terms"
                  className="text-gray-600 dark:text-gray-400 hover:text-royal-purple dark:hover:text-royal-purple transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacy"
                  className="text-gray-600 dark:text-gray-400 hover:text-royal-purple dark:hover:text-royal-purple transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/cookies"
                  className="text-gray-600 dark:text-gray-400 hover:text-royal-purple dark:hover:text-royal-purple transition-colors"
                >
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/dispute-resolution"
                  className="text-gray-600 dark:text-gray-400 hover:text-royal-purple dark:hover:text-royal-purple transition-colors"
                >
                  Dispute Resolution
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-dark-primary mb-4">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href="mailto:support@royaltysuite.com"
                  className="text-gray-600 dark:text-gray-400 hover:text-royal-purple dark:hover:text-royal-purple transition-colors"
                >
                  support@royaltysuite.com
                </a>
              </li>
              <li>
                <a 
                  href="tel:+1234567890"
                  className="text-gray-600 dark:text-gray-400 hover:text-royal-purple dark:hover:text-royal-purple transition-colors"
                >
                  +1 (234) 567-890
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t dark:border-dark-border">
          <p className="text-gray-500 dark:text-gray-400 text-sm text-center">
            © {new Date().getFullYear()} RoyaltySuite. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}